module.exports = __webpack_public_path__ + "static/media/avdhut.1bd3f3ff.jpeg";